{
  "apiVersion": "1",
  "data": {
    "id": "815",
    "text": "уууууууууууууууууууууууууууууууууererуууууууууууууууууввввввуууууууууууууууууууууууууууууууууууыввввввууууууууууууууууууууууууууу",
    "type": { "id": "MEETING", "name": "Встреча" },
    "author": { "id": "TMOROZOVA", "name": "Морозова Т. В." },
    "customer": {
      "id": "555",
      "name": "Современные медицинские технологии ООО"
    },
    "construction": { "id": "333", "name": "5555" },
    "deadline": "2022-01-01T12:00:01Z",
    "priority": { "id": "NORMAL", "name": "Обычный" },
    "status": { "id": "NEW", "name": "Не выполнена" },
    "canEdit": true,
    "assignees": [
      {
        "assignee": { "id": "YSHEGLOV", "name": "Щеглов Ю. В." },
        "status": { "id": "NEW", "name": "Не выполнена" },
        "statusTime": null,
        "result": "уууууууууууууууууууууууууууууууууererуууууууууууууууууввввввуууууууууууууууууууууууууууууууууууыввввввууууууууууууууууууууууууууу"
      }
    ],
    "unreadMessagesCount": 2
  }
}
